import React from "react"
import { Box, Flex } from "rebass"

import { ArrowLink } from "./arrow-link"

const CenterPage = ({ anchor, nextLink, photo, mobilePhoto, title }) => {
  return (
    <Flex
      as="section"
      id={anchor}
      color="#fffdba"
      height="100vh"
      p={4}
      sx={{
        backgroundColor: "#290000",
        flexDirection: "column",
        backgroundImage: ["none", `url(${photo})`],
        backgroundSize: ["contain", "600px"],
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center 30px",
        justifyContent: ["flex-end"],
        position: "relative",
      }}
    >
      <Box width="100%" display={["block", "none"]} flex={1}>
        {mobilePhoto}
      </Box>
      {title && (
        <Box
          sx={{
            flex: [0, 0, 0],
            top: [0, 50],
            position: "relative",
            textAlign: ["left", "right"],
            right: 0,
            bottom: 0,
            pt: 4,
            mb: 4,
          }}
        >
          {title}
        </Box>
      )}
      {nextLink && (
        <Box
          sx={{
            height: "48px",
            position: "relative",
            bottom: 0,
            width: "100%",
            right: 0,
            textAlign: "center",
          }}
        >
          <ArrowLink href={nextLink} />
        </Box>
      )}
    </Flex>
  )
}

export default CenterPage
